import { WayflyerSchemas } from "api-types";
import { defineMessages, type MessageDescriptor } from "react-intl";

/**
 * Friendly, sentence-case, translatable label for each company role.
 *
 * Typed as `Record<CompanyRole, MessageDescriptor>` so the build fails if a role is added without a label, and wrapped
 * in `defineMessages` (with the role baked into each message id) so the strings are picked up by
 * `pnpm extract-translations`.
 *
 * Render with `intl.formatMessage(COMPANY_ROLE_MESSAGES[role])`. For plain, untranslated labels see
 * {@link companyRoleLabels}.
 */
export const COMPANY_ROLE_MESSAGES: Record<WayflyerSchemas.CompanyRole, MessageDescriptor> = defineMessages({
  admin: {
    id: "member-roles role label admin",
    defaultMessage: "Admin",
  },
  financial_assistant: {
    id: "member-roles role label financial_assistant",
    defaultMessage: "Financial assistant",
  },
  user: {
    id: "member-roles role label user",
    defaultMessage: "User",
  },
});
